import { createVanIconComponent } from "./van"

const Completed = createVanIconComponent("completed")
export default Completed
